// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"4c9bece9","639":"75e99425"}[chunkId] + ".chunk.js";
};